import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-950/95 backdrop-blur-md shadow-lg shadow-black/20'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo */}
            <Link
              to="/"
              className="flex items-center gap-2 shrink-0"
              aria-label="51黑料网首页"
            >
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500">
                <span className="text-background-50 font-black text-lg md:text-xl">51</span>
              </div>
              <div className="hidden sm:block">
                <span className="text-lg md:text-xl font-bold text-foreground-100 tracking-tight">
                  黑料网
                </span>
                <span className="block text-[10px] md:text-xs text-accent-500 -mt-0.5">
                  吃瓜不打烊
                </span>
              </div>
            </Link>

            {/* Desktop Nav */}
            <div className="hidden lg:flex items-center gap-1">
              <Link
                to="/"
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/'
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-800/50'
                }`}
              >
                首页
              </Link>
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'text-primary-400 bg-primary-500/10'
                      : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-800/50'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === '/about'
                    ? 'text-primary-400 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-foreground-100 hover:bg-background-800/50'
                }`}
              >
                关于我们
              </Link>
            </div>

            {/* Right side - search + hamburger */}
            <div className="flex items-center gap-3">
              <div className="hidden md:flex items-center">
                <Link
                  to="/category/daily-gossip"
                  className="px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  <i className="ri-fire-line mr-1" />今日黑料
                </Link>
              </div>
              <button
                className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-200 hover:text-foreground-100 hover:bg-background-800/50 transition-colors cursor-pointer"
                onClick={() => setMobileOpen(!mobileOpen)}
                aria-label="切换导航菜单"
              >
                <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-background-950/98 backdrop-blur-xl transition-all duration-300 lg:hidden ${
          mobileOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
        style={{ top: '64px' }}
      >
        <div className="px-4 py-6 flex flex-col gap-2">
          <Link
            to="/"
            className={`px-4 py-3 rounded-lg text-base font-medium transition-colors ${
              location.pathname === '/'
                ? 'text-primary-400 bg-primary-500/10'
                : 'text-foreground-200 hover:text-foreground-100 hover:bg-background-800/50'
            }`}
          >
            <i className="ri-home-line mr-2" />首页
          </Link>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-4 py-3 rounded-lg text-base font-medium transition-colors ${
                location.pathname === `/category/${cat.slug}`
                  ? 'text-primary-400 bg-primary-500/10'
                  : 'text-foreground-200 hover:text-foreground-100 hover:bg-background-800/50'
              }`}
            >
              <i className={`${cat.icon} mr-2`} />
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-3 rounded-lg text-base font-medium transition-colors ${
              location.pathname === '/about'
                ? 'text-primary-400 bg-primary-500/10'
                : 'text-foreground-200 hover:text-foreground-100 hover:bg-background-800/50'
            }`}
          >
            <i className="ri-information-line mr-2" />关于我们
          </Link>
        </div>
      </div>
    </>
  );
}